import './SelectionInfo.scss';

import { Button } from 'antd';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getClosestButton } from '@lib/popups';
import React from 'react';
import { SonarText } from '@ui/text';

import { Else, If, Then, When } from 'react-if';
import { SonarAlert, SonarAlertProps } from '@ui/SonarAlert';

export interface SelectionInfoProps extends Omit<SonarAlertProps, 'message'> {
	alwaysShowCount?: boolean;
	bordered: boolean;
	id?: string;
	onEdit?: (button: HTMLElement) => void;
	onSelectAll: () => void;
	selectedCount: number;
	selectionType?: string;
	totalCount: number;
}

export const SelectionInfo: React.FC<SelectionInfoProps> = ({
	active,
	alwaysShowCount = false,
	bordered,
	id,
	onEdit,
	onSelectAll,
	selectedCount,
	selectionType = COPY_SPECIFIC.ITEMS,
	totalCount,
	...otherProps
}) => {
	const allSelected = selectedCount === totalCount;
	const noneSelected = selectedCount === 0;

	const allText = allSelected ? `${COPY_SPECIFIC.ALL} ` : '';
	const selectedText = `${allText}${selectedCount} ${selectionType} ${COPY_SPECIFIC.SELECTED}`;
	const editText = `${COPY_SPECIFIC.EDIT} ${allText}${selectedCount} ${selectionType}`;
	const totalCountText = `${totalCount} ${selectionType}`;

	const selectAllButtonText = `${COPY_SPECIFIC.SELECT_ALL} ${totalCount} ${selectionType}`;

	const selectionInfoMessage = () =>
		<>
			<If condition={ Boolean(onEdit) }>
				<Then>
					<Button
						onClick={ (e) => onEdit && onEdit(getClosestButton(e.target as HTMLElement)) }
						type='primary'>
						{ editText }
					</Button>
				</Then>
				<Else>{ noneSelected ? selectionType : selectedText }</Else>
			</If>
			<When condition={ !noneSelected && !allSelected }>
				<Button
					id={ `${id}-select-all-button` }
					onClick={ onSelectAll }
					size='small'
					type='link'>
					{ selectAllButtonText }
				</Button>
			</When>
		</>;

	return (
		<>
			<SonarAlert
				active={ active }
				className={ classNames('selection-info', { bordered }) }
				closable
				closeIcon={
					<span className='anticon anticon-close'>
						{ COPY_SPECIFIC.CLEAR_SELECTION }
					</span>
				}
				message={ selectionInfoMessage() }
				type='info'
				{ ...otherProps } />
			<When condition={ alwaysShowCount && !active }>
				<SonarText> { totalCountText } </SonarText>
			</When>
		</>
	);
};
